import { BrowserMultiFormatReader } from "@zxing/browser";
import Tesseract from "tesseract.js";

const zxingReader = new BrowserMultiFormatReader();

function extractTicketNumber(rawText) {
    const matches = String(rawText || "").match(/\b\d{3,8}\b/g);
    if (!matches || matches.length === 0) return "";
    const sorted = matches.sort((a, b) => b.length - a.length);
    return sorted[0];
}

export function parseTicketFromPayload(qrText) {
    const raw = String(qrText || "").trim();
    if (!raw) return "";

    const explicit = raw.match(/^PP:TICKET:(\d{3,8})$/i);
    if (explicit) return explicit[1];

    return extractTicketNumber(raw);
}

function supportsNativeBarcodeDetector() {
    return typeof window !== "undefined" && "BarcodeDetector" in window;
}

async function loadImageFromUrl(objectUrl) {
    return await new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = objectUrl;
    });
}

async function tryNativeBarcodeDetector(objectUrl) {
    if (!supportsNativeBarcodeDetector()) return "";

    const img = await loadImageFromUrl(objectUrl);
    const detector = new window.BarcodeDetector({ formats: ["qr_code"] });
    const results = await detector.detect(img);
    if (!results || results.length === 0) return "";

    const rawValue = results[0]?.rawValue || "";
    return parseTicketFromPayload(rawValue);
}

async function tryZxingQr(objectUrl) {
    const qrResult = await zxingReader.decodeFromImageUrl(objectUrl);
    return parseTicketFromPayload(qrResult?.getText?.() || "");
}

async function tryOcrNumeric(file) {
    const result = await Tesseract.recognize(file, "eng", {
        tessedit_char_whitelist: "0123456789",
    });
    return extractTicketNumber(result?.data?.text || "");
}

// Future-proof decode adapter:
// 1) Native BarcodeDetector
// 2) ZXing fallback
// 3) OCR fallback
export async function decodeTicketFromFile(file) {
    if (!file) return "";
    const objectUrl = URL.createObjectURL(file);

    try {
        try {
            const nativeTicket = await tryNativeBarcodeDetector(objectUrl);
            if (nativeTicket) return nativeTicket;
        } catch (err) {
            // Native decode unavailable/failed, continue.
        }

        try {
            const zxingTicket = await tryZxingQr(objectUrl);
            if (zxingTicket) return zxingTicket;
        } catch (err) {
            // No QR found by ZXing, continue to OCR.
        }

        const ocrTicket = await tryOcrNumeric(file);
        return ocrTicket || "";
    } finally {
        URL.revokeObjectURL(objectUrl);
    }
}
